'use strict';
define([], function () {
    return {
        templateUrl: 'app/modules/seospider/components/status-code-bar/status-code-bar.html',
        bindings: {
            inAnimation: '<',
            codesByDepth: '<',
            /* The workspace shows this title (and its tooltip) in the widget head. */
            hideTitle: '<'
        },
        controller: ['$scope', '$mdMedia', function ($scope, $mdMedia) {
            var vm = $scope;
            vm.$mdMedia = $mdMedia;
            vm.inAnimation = true;
            vm.dataSuccess = [];
            vm.dataRedirect = [];
            vm.dataError = [];
            vm.colors = ['#2ed47a', '#e8c84f', '#ff9700'];
            vm.labels = [1, 2, 3, 4, 5, 6];

            vm.isLoaded = false;

            vm.data = [
                vm.dataSuccess,
                vm.dataRedirect,
                vm.dataError
            ];

            vm.datasetOverride = [{
                label: "Success (2xx)",
                borderWidth: 0,
                backgroundColor: '#2ed47a',
            },
                {
                    label: "Redirect (3xx)",
                    borderWidth: 0,
                    backgroundColor: '#e8c84f',
                },
                {
                    label: "Client Error (4xx)",
                    borderWidth: 0,
                    backgroundColor: '#ff9700',
                }
            ];

            vm.chartOpts = {
                responsive: true,
                animation: {},
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    animation: false,
                    align: 'left',
                    position: 'bottom',
                    labels: {
                        usePointStyle: true
                    },
                    boxWidth: 10,
                },
                title: {
                    display: false,
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        display: false,
                        gridLines: {
                            color: 'transparent',
                            zeroLineColor: 'transparent',
                        },
                        barPercentage: 1.0,
                        categoryPercentage: 0.8,
                        ticks: {
                            suggestedMax: 6,
                        }
                    }],
                    yAxes: [{
                        position: 'right',
                        stacked: true,
                        display: true,
                        gridLines: {
                            color: 'rgba(118, 110, 148, 0.12)',
                            zeroLineColor: 'rgba(118, 110, 148, 0.12)',
                        },
                        /* No fixed ceiling: a small site would otherwise draw a
                           single bar against an empty 0-100 scale. */
                        ticks: {}
                    }]
                }
            }

            vm.$watchCollection('$ctrl.codesByDepth', function (codesByDepth) {
                if (codesByDepth && codesByDepth.length) {
                    setData(codesByDepth);
                }
                if (codesByDepth && !codesByDepth.length) {
                    vm.dataSuccess = [0];
                    vm.dataRedirect = [0];
                    vm.dataError = [0];
                    vm.data = [
                        vm.dataSuccess,
                        vm.dataRedirect,
                        vm.dataError
                    ];
                }
            });

            vm.$watch('$ctrl.inAnimation', function (inAnimation) {
                if (!inAnimation) {
                    vm.chartOpts.animation.duration = 0;
                }
            })

            function getCountFromJson(codeCounts, status) {
                var codeCountForDepth = 0;
                codeCounts.forEach(function (code) {
                    if (code.status === status) {
                        codeCountForDepth = code.count;
                    }
                })
                return codeCountForDepth;
            }

            function setData(codesByDepth) {
                vm.labels = [];
                vm.dataSuccess = [];
                vm.dataRedirect = [];
                vm.dataError = [];
                angular.forEach(codesByDepth, function (codeByDepth) {
                    var depth = Number(codeByDepth && codeByDepth.depth);
                    if (!isFinite(depth)) return;
                    vm.labels.push(depth);

                    var codeCounts = codeByDepth && codeByDepth.json;
                    if (typeof codeCounts === 'string') {
                        try {
                            codeCounts = JSON.parse(codeCounts);
                        } catch (error) {
                            codeCounts = [];
                        }
                    }
                    if (!Array.isArray(codeCounts)) codeCounts = [];

                    var countSuccess = getCountFromJson(codeCounts, 200);
                    var countRedirect = getCountFromJson(codeCounts, 301);
                    var countError = getCountFromJson(codeCounts, 404);

                    vm.dataSuccess.push(countSuccess);
                    vm.dataRedirect.push(countRedirect);
                    vm.dataError.push(countError);
                });

                vm.data = [
                    vm.dataSuccess,
                    vm.dataRedirect,
                    vm.dataError
                ];
            }
        }]
    };
});
